import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SubscriptionFeeRepositoryService } from 'reg-hub-common';
import { ListComponent, SubscriptionFee,Invoice } from 'reg-hub-common';

@Component({
  selector: 'app-subscription-fees-list',
  templateUrl: './subscription-fees-list.component.html',
  styleUrl: './subscription-fees-list.component.css',
  animations: [
        trigger('detailExpand', [
            state('collapsed,void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionFeesListComponent extends ListComponent<SubscriptionFee> {
    @Input() invoice!: Invoice;
    protected expandedFee: SubscriptionFee | null = null;

    displayedColumns: string[] = [
        'productCode',
        'description',
        'taxCode',
        'amount',
        'tax',
        'total',
        'added',
    ];

    constructor(
        repo: SubscriptionFeeRepositoryService,
        private router: Router,) {
        super(repo);
    }
}